import React, { ReactNode } from 'react';
import { PartialSearchingProps, SearchingProps } from 'modules/Shared/type';
import { PageProps } from 'modules/Layout/type';
import { managePageAction, ManagePageAction } from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { breadcrumbRouteHelpFindPlants } from 'modules/Plants/breadcrumbs';
import { connect } from 'react-redux';
import Listing from 'modules/Layout/component/Listing';
import HelpFindPlantPagination from 'modules/Plants/container/Pagination/HelpFindPlant';
import HelpFindPlantPerPage from 'modules/Plants/container/PerPage/HelpFindPlant';
import { createSearchingProps } from 'modules/Shared/helper/params';
import {
  setHelpFindPlantListParamsAction,
  SetHelpFindPlantListParamsAction
} from 'modules/Plants/action/list';
import { RootState } from 'app/reducer';
import HelpFindPlantFilter from 'modules/Plants/container/Filter/HelpFindPlant';
import HelpFindPlantTable from 'modules/Plants/container/Table/HelpFindPlant';
import HelpFindPlant from 'modules/Plants/model/HelpFindPlant';

export interface StateProps {
  fetching: boolean;
  type: string;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  setParams: (
    payload: PartialSearchingProps
  ) => SetHelpFindPlantListParamsAction;
}

export type Props = StateProps & DispatchProps;

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setHelpFindPlantListParamsAction(payload))
});

export const mapState = (state: RootState): StateProps => {
  const { fetching } = state.plant.list;
  const { type } = state.layout.page;

  return { fetching, type };
};

export class HelpFindPlantsListView extends React.Component<Props> {
  protected searchProps: SearchingProps;

  constructor(props: Props) {
    super(props);

    this.searchProps = createSearchingProps(
      window.location.hash,
      HelpFindPlant.getFilterableAttributes(),
      HelpFindPlant.getSortableAttributes()
    );
  }

  componentDidMount(): void {
    const { managePage, setParams } = this.props;

    managePage({
      title: 'Help find plant',
      breadcrumb: breadcrumbRouteHelpFindPlants()
    });

    setParams(this.searchProps);
  }

  render(): ReactNode {
    const { fetching, type } = this.props;
    const { filter } = this.searchProps;

    if (type) return null;

    return (
      <div className="row help-find-plants-view">
        <div className="col-12">
          <Listing
            table={<HelpFindPlantTable />}
            filter={<HelpFindPlantFilter values={filter} />}
            pagination={<HelpFindPlantPagination />}
            perPage={<HelpFindPlantPerPage />}
            loading={fetching}
          />
        </div>
      </div>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(HelpFindPlantsListView);
